import { render, staticRenderFns } from "./BatchOperation.vue?vue&type=template&id=ed72fbdc&scoped=true&"
import script from "./BatchOperation.vue?vue&type=script&lang=js&"
export * from "./BatchOperation.vue?vue&type=script&lang=js&"
import style0 from "./BatchOperation.vue?vue&type=style&index=0&id=ed72fbdc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed72fbdc",
  null
  
)

export default component.exports